module.exports = __webpack_public_path__ + "img/Argentine.c52054ac.svg";